import { render } from "./chatHistory.vue?vue&type=template&id=e57b853c"
import script from "./chatHistory.vue?vue&type=script&lang=js"
export * from "./chatHistory.vue?vue&type=script&lang=js"

import "./chatHistory.vue?vue&type=style&index=0&id=e57b853c&lang=scss"

import exportComponent from "/data/jenkins/workspace/b2c-im-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__